import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSideMenuSelectedItem, setToolbarTitle } from "../../../redux/actions";
import { releaseNote } from "../../../network/api";
import Tasks from "../../util/tasks";
import Loading from "../../util/page-loading";
import {tasks_done_in_last_release} from "../../../resources/string/strings"

class ReleaseNote extends Component {
  state = {
    pageTitle: "ریلیزنوت",
    pageTag: "releases",
    data: undefined
  };

  componentDidMount() {
    this.props.setSideMenuSelectedItem(this.state.pageTag);
    this.props.setToolbarTitle(this.state.pageTitle);
    document.title = this.state.pageTitle;
    this.callReleaseNoteApi();
  }

  render() {

    return (

      <div className="fragment  text-center">
        {(this.state.data === undefined || this.state.data === null) && <Loading/>}

        {this.state.data !== undefined && this.state.data !== null && 
        <div style={{ marginBottom: 36 }} className="col-12 row mx-auto">

          <div className="app-card col-12 mt-0">

          {this.state.data !== undefined && this.state.data !== null && this.state.data.length > 0 &&
                <div className="mt-3">
                  <Tasks
                    tasks={this.state.data}
                    title={tasks_done_in_last_release}
                  />
                </div>
              }
          </div>

        </div>
         }
      </div>
    );


  }

  getQueryString(tag, defaultValue) {
    const query = new URLSearchParams(this.props.location.search);
    let value = query.get(tag);
    if (value === null) {
      value = defaultValue;
    }
    return value;
  }

  /****
  ** NETWORK
  *****/

  callReleaseNoteApi() {
    var id = this.getQueryString("i", null)
    this.setState({ loading: true })
    releaseNote(id, this.handleReleaseNoteApiSuccess, this.handleReleaseNoteFailure);
  }

  handleReleaseNoteApiSuccess = (data) => {
    this.setState({
      loading: false,
      data: data
    });
  };

  handleReleaseNoteFailure = (error) => {
    this.setState({ loading: false });
  }

}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem, setToolbarTitle: setToolbarTitle }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ReleaseNote);
